import { render, staticRenderFns } from "./ContentsOpen.vue?vue&type=template&id=4ff7238b&"
import script from "./ContentsOpen.vue?vue&type=script&lang=js&"
export * from "./ContentsOpen.vue?vue&type=script&lang=js&"
import style0 from "./ContentsOpen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VMain,VRow})
